import { useRef, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { SelectMessages } from '../slice/selectors';

export function useAutoScroll({ shouldScrollToBottom = true }: { shouldScrollToBottom?: boolean }) {
  // const messagesEndRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const userScrolledUpRef = useRef(false);
  const messages = useSelector(SelectMessages);

  // Function to scroll to bottom - scroll the container explicitly to avoid ancestor/page scrolling
  const scrollToBottom = useCallback(() => {
    // if (messagesEndRef.current) {
    //   messagesEndRef.current.scrollIntoView({ behavior: 'auto', block: 'end', inline: 'nearest' });
    // }
    if (shouldScrollToBottom) {
      const el = containerRef.current;
      if (!el) return;

      el.scrollTo({
        top: el.scrollHeight,
        behavior: 'smooth',
      });
    }
  }, [shouldScrollToBottom]);

  // Function to check if user has scrolled up
  const checkUserScroll = useCallback(() => {
    const el = containerRef.current;
    if (!el) return;

    const { scrollTop, scrollHeight, clientHeight } = el;
    const isAtBottom = scrollTop + clientHeight >= scrollHeight - 10;

    userScrolledUpRef.current = !isAtBottom;
  }, []);

  // Auto-scroll when new messages arrive or streaming updates
  useEffect(() => {
    // Only auto-scroll if user hasn't manually scrolled up
    if (!userScrolledUpRef.current) {
      scrollToBottom();
    }
  }, [messages, scrollToBottom]);

  // Reset user scroll flag when streaming starts (new message)

  return {
    // messagesEndRef,
    containerRef,
    scrollToBottom,
    checkUserScroll,
  };
}
